export enum ItemAttributeTypeEnum {
  Logic = 'logic',
  Text = 'text',
  Digits = 'digits',
  Year = 'year',
  RangeOfNumbers = 'rangeOfNumbers',
  SingleChoice = 'singleChoice',
  MultipleChoice = 'multipleChoice',
}
